/**
 * Configuración de entorno del Admin Web.
 *
 * `VITE_API_URL`:
 * - vacío (`''`) => rutas relativas; en desarrollo usa el proxy de Vite y en
 *   producción el reverse proxy (nginx) que sirve la app.
 * - ausente (`undefined`) => default `http://localhost:3000`.
 * - absoluto => el navegador llama directo al backend (sujeto a CORS).
 */
function normalizeBaseUrl(value: string): string {
  return value.endsWith('/') ? value.slice(0, -1) : value;
}

const rawBaseUrl = import.meta.env.VITE_API_URL;

export const API_BASE_URL = normalizeBaseUrl(rawBaseUrl === undefined ? 'http://localhost:3000' : rawBaseUrl);
